// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__22AjL","title":"FrontImage_title___kFSI"};